import Shopping from "../imgs/templates/Shopping.png";
import Github from "../imgs/templates/Github.png";
import MemoryGame from "../imgs/templates/MemoryGame.png";
import Fruits from "../imgs/templates/Fruits.png";
import Camera from "../imgs/templates/Camera.png";
import Movies from "../imgs/templates/movies.png";
const Projects = [
  {
    id: 1,
    name: "Seacrh Github User",
    small: "Reactjs  & Github APIS",
    link: "https://seach-github-users.netlify.app/",
    img: Github,
  },
  {
    id: 2,
    name: "Fruits Fresh",
    small: "Reactjs & Paypal APIS",
    link: "https://fruits-national.netlify.app/",
    img: Fruits,
  },
  {
    id: 3,
    name: "Shopping",
    small: "Reactjs & Paypal APIS",
    link: "https://shopping-template.netlify.com/",
    img: Shopping,
  },
  {
    id: 5,
    name: "Camera",
    small: "Reactjs & Paypal APIS",
    link: "https://camera-products.netlify.app/",
    img: Camera,
  },
  {
    id: 6,
    name: "Seacrh Movies",
    small: "Reactjs & Axios",
    link: "https://search-movies-react.netlify.app/",
    img: Movies,
  },
  {
    id: 4,
    name: "Memory Game",
    small: "JavaScript",
    link: "https://memory-game-play.netlify.app/",
    img: MemoryGame,
  },
];

export default Projects;
